const palmettoFinanceOrgAlias = 'sabal';
const lightEPCOrgAlias = 'light-epc';

export const isPalmettoFinanceUserIncludingRoot = (claims: any): boolean => {
  return claims?.org === palmettoFinanceOrgAlias || claims?.rootOrg === palmettoFinanceOrgAlias;
};

/**
 * @description Checks if the user is an internal user based on their claims. Based off the same method used in the server.
 * @param claims The user claims object containing organization information.
 * @param useRootOrg If to use the rootOrg for checking the user.
 * @returns Whether this user is an internal user.
 */
export const isInternalUser = (claims: any, useRootOrg: boolean) => {
  const isSabalUser = useRootOrg
    ? isPalmettoFinanceUserIncludingRoot(claims)
    : claims?.org === palmettoFinanceOrgAlias;
  const isLightEPCUser = useRootOrg
    ? claims?.org === lightEPCOrgAlias || claims?.rootOrg === lightEPCOrgAlias
    : claims?.org === lightEPCOrgAlias;

  return isSabalUser || isLightEPCUser;
};
